export const  PEASANT = 'peasant';
export const PRINCESS = 'princess';
export const KNIGHT = 'knight';
export const WIZARD = 'wizard_2';
export const SKELETON = 'skeleton';

export const VTFAN = 'vtfan';
export const VTSUPERFAN = 'vtsuperfan';
export const VTWIZARD = 'vtwizard';
export const VTYODA = 'vtyoda';
export const VTSKELETON = 'vtskeleton';
export const VTMANDALORIAN = 'vtmandalorian';
export const VTCAPTAINMARVEL = 'vtcaptainmarvel';
export const VTWONDERWOMAN = 'vtwonderwoman';
export const VTSPIDERMAN = 'vtspiderman';

export const VTSUPERMAN = 'vtsuperman';
export const VTBATMAN = 'vtbatman';
export const VTBLACKPANTHER = 'vtblackpanther';
export const VTCAPTAINAMERICA = 'vtcaptainamerica';
export const VTDRSTRANGE = 'vtdrstrange';
export const VTC3PO = 'vtC3PO';
export const VTR2D2 = 'vtR2D2';

export const VTBIDEN = 'vtbiden';
export const VTGROOT = 'vtgroot';
export const VTHULK = 'vthulk';
export const VTTHOR = 'vtthor';
export const VTTRUMP = 'vttrump';

export const SANTA = 'santa';
export const SNOWMAN = 'snowman';
